import React, { useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import ChooseMemberPass from "../choosememberPass/chooseMemberPass";

// types
import { AddCommunityMembersProps } from "./types";

// assets
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import rightIcon from "bodycodi/cmap/app/svg/icon_right_arrow_small.svg";
import GooglyEyes from "bodycodi/cmap/app/img/googly_eyes.png";
import OneToOneIcon from "bodycodi/cmap/app/svg/community_onetoone_icon.svg";
import GroupIcon from "bodycodi/cmap/app/svg/community_group_icon.svg";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";

const AddCommunityMembers = ({ chosenMembers, setChosenMembers }: AddCommunityMembersProps) => {
  const { dispatch } = useContext(DispatchContext);

  const renderProfilePics = () => {
    return Object.keys(chosenMembers).map((d: any, i: number) => {
      const imgUrl = isEmpty(chosenMembers[d].imageUrl)
        ? isEmpty(chosenMembers[d].imgUrl)
          ? empty
          : chosenMembers[d].imgUrl
        : chosenMembers[d].imageUrl;

      if (i < 2) {
        return (
          <div key={i} className="profile">
            <img src={imgUrl} />
          </div>
        );
      }
    });
  };

  const renderAdditionalText = () => {
    let memberText;
    if (Object.keys(chosenMembers).length === 1) {
      memberText = chosenMembers[Object.keys(chosenMembers)[0]].name + "님";
    } else if (Object.keys(chosenMembers).length === 2) {
      memberText =
        chosenMembers[Object.keys(chosenMembers)[0]].name +
        "님, " +
        chosenMembers[Object.keys(chosenMembers)[1]].name +
        "님";
    } else if (Object.keys(chosenMembers).length > 2) {
      memberText =
        chosenMembers[Object.keys(chosenMembers)[0]].name +
        "님 외 " +
        (Object.keys(chosenMembers).length - 1) +
        "명";
    }
    return memberText;
  };

  const openMemberPop = () => {
    dispatch({ type: "UPDATE", data: { comunityMemberList: chosenMembers } });
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_MEMBER_PASS_COMUNITY_POP",
      open: { chooseMemberPassComunityPop: true },
    });
  };

  if (isEmpty(chosenMembers)) {
    return (
      <>
        <div className="add-comunity-member-info">
          <img src={GooglyEyes} />
          <span>이 글은 아래 선택한 회원에게만 보여집니다.</span>
        </div>

        <div className="add-comunity-member-list">
          <div className="profile-wrap" onClick={openMemberPop}>
            <div className="profile-list-wrap">
              <div className="profile-list">
                <img src={empty} className="profile" />
              </div>
            </div>
            회원님을 선택해주세요.
            <img src={rightIcon} className="right-arrow" />
          </div>
          <ChooseMemberPass setMember={setChosenMembers} chooseMemberList={chosenMembers} />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="add-comunity-member-info">
        <img src={GooglyEyes} />
        <span>이 글은 아래 선택한 회원에게만 보여집니다.</span>
      </div>
      <div className="add-comunity-member-list">
        <div className="profile-wrap" onClick={openMemberPop}>
          <div className="profile-list-wrap">
            <div className="profile-list">{renderProfilePics()}</div>
            {Object.keys(chosenMembers).length > 2 && (
              <div className="more">+{Object.keys(chosenMembers).length - 2}</div>
            )}
          </div>
          <span>{renderAdditionalText()}</span>

          <div className="right-arrow">
            {Object.keys(chosenMembers)?.length > 1 ? (
              <img src={GroupIcon} />
            ) : (
              <img src={OneToOneIcon} />
            )}
            <img src={rightIcon} />
          </div>
        </div>
        <ChooseMemberPass setMember={setChosenMembers} chooseMemberList={chosenMembers} />
      </div>
    </>
  );
};

export default AddCommunityMembers;
